import React, { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Amchartmenu } from "../../routers/Dashboard/children/ChartDownload";
import _ from "lodash";
import { reviewTranslationMap } from "../../../src/utils/reviewStarTranslation";

am4core.useTheme(am4themes_animated);

class ResponseTimeBarChart extends Component {
	constructor(props) {
		super(props);
		this.chartId =
			"responsetimegraph-" + Math.random().toString(36).substr(2, 9);
	}
	componentDidMount() {
		this.responseTimeRender();
	}

	responseTimeRender() {
		// Dispose any previous chart instance to avoid memory leaks
		if (this.responseTimeBarChart) {
			this.responseTimeBarChart.dispose();
		}

		// Create a new chart
		const responseTimeBarChart = am4core.create(
			this.chartId,
			am4charts.XYChart,
		);

		responseTimeBarChart.data = this.props.chartData;

		// Category Axis (Y)
		const categoryAxis = responseTimeBarChart.yAxes.push(
			new am4charts.CategoryAxis(),
		);
		categoryAxis.dataFields.category = "review";
		categoryAxis.renderer.minGridDistance = 20;
		categoryAxis.tooltip.disabled = true;
		categoryAxis.renderer.grid.template.disabled = true;
		categoryAxis.renderer.line.strokeOpacity = 1;
		categoryAxis.renderer.line.strokeWidth = 1;
		categoryAxis.renderer.line.stroke = "#8c8c8c";
		categoryAxis.renderer.labels.template.enabled = true;

		// Axis ticks
		categoryAxis.renderer.ticks.template.disabled = false;
		categoryAxis.renderer.ticks.template.strokeOpacity = 1;
		categoryAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
		categoryAxis.renderer.ticks.template.strokeWidth = 2;
		categoryAxis.renderer.ticks.template.length = 7;

		// Translate category labels
		categoryAxis.renderer.labels.template.adapter.add("textOutput", (text) => {
			return reviewTranslationMap[text] || text;
		});

		// Value Axis (X)
		const valueAxis = responseTimeBarChart.xAxes.push(
			new am4charts.ValueAxis(),
		);
		valueAxis.renderer.grid.template.disabled = true;
		valueAxis.renderer.minWidth = 50;
		valueAxis.min = 0;
		valueAxis.max = 100;
		valueAxis.cursorTooltipEnabled = false;
		valueAxis.renderer.line.strokeOpacity = 1;
		valueAxis.renderer.line.strokeWidth = 2;
		valueAxis.renderer.line.stroke = "#8c8c8c";
		valueAxis.renderer.opposite = false;
		valueAxis.renderer.minGridDistance = 20;

		// Axis ticks
		valueAxis.renderer.ticks.template.disabled = false;
		valueAxis.renderer.ticks.template.strokeOpacity = 1;
		valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
		valueAxis.renderer.ticks.template.strokeWidth = 2;
		valueAxis.renderer.ticks.template.length = 7;

		// Create Series Helper
		const createSeries = (field, name, color) => {
			const series = responseTimeBarChart.series.push(
				new am4charts.ColumnSeries(),
			);
			series.dataFields.valueX = field;
			series.dataFields.categoryY = "review";
			series.tooltipText = "{name}: {valueX.formatNumber('#.0')}[/]%";
			series.stacked = true;
			series.fill = am4core.color(color);
			series.stroke = am4core.color(color);
			series.name = name;
		};

		// Create series for all items with legend enabled
		_.map(this.props.colourMap, (item, key) => {
			if (item.shouldEnableLegend) {
				createSeries(key, item.label, item.color);
			}
		});

		// Cursor
		responseTimeBarChart.cursor = new am4charts.XYCursor();

		// Export menu
		if (this.props.isShowDownload) {
			responseTimeBarChart.exporting.menu = new am4core.ExportMenu();
			responseTimeBarChart.exporting.menu.items = _.cloneDeep(Amchartmenu);
			responseTimeBarChart.exporting.timeoutDelay = 8000;
			responseTimeBarChart.exporting.dataFields = this.props.downloadHeader;
			responseTimeBarChart.exporting.filePrefix = "Response Distribution";
		}

		// Legend
		responseTimeBarChart.legend = new am4charts.Legend();

		// Save reference
		this.responseTimeBarChart = responseTimeBarChart;
	}

	componentDidUpdate(prevProps) {
		// Only update when ResponseReferenceHistogram changes
		if (
			!_.isEqual(
				prevProps.ResponseReferenceHistogram,
				this.props.ResponseReferenceHistogram,
			)
		) {
			// Check if chart exists and is valid
			if (
				this.responseTimeBarChart &&
				typeof this.responseTimeBarChart.invalidateSize === "function" &&
				!this.responseTimeBarChart.isDisposed()
			) {
				this.responseTimeBarChart.data = this.props.chartData;
				this.responseTimeBarChart.invalidateSize();
			} else {
				// If chart is disposed or invalid, re-render it
				this.responseTimeRender();
			}
		}
	}

	componentWillUnmount() {
		if (this.responseTimeBarChart) {
			this.responseTimeBarChart.dispose();
			this.responseTimeBarChart = null;
		}
	}

	render() {
		return (
			<div
				id={this.chartId}
				style={{ width: "100%", height: "100%" }}></div>
		);
	}
}

export default ResponseTimeBarChart;
